<script>
  import * as turf from "@turf/turf";
  import { onMount } from "svelte";
  import { Tooltip, tooltip } from "@svelte-plugins/tooltips";
  import {
    isCalculate,
    drawClicked,
    bufferZoneValue,
    ParkingDensitySP,
    drawingMode,
  } from "../../../store.js";
  import { treemapSquarify } from "d3";
  import CalculateOperationZonePotential from "./CalculateOperationZonePotential.svelte";
  import { buffer } from "turf";
  export let map;
  export let Draw;
  let parkingDensity = 100;
  let bufferDrawzones = 2;
  $: $bufferZoneValue = bufferDrawzones;
  $: $ParkingDensitySP = parkingDensity;

  let poly;

  onMount(() => {});

  function drawPoly() {
    $drawingMode = true;

    Draw.changeMode("draw_polygon");
    map.getCanvas().style.cursor = "pointer";
  }
  function clearPoly() {
    Draw.deleteAll();
    if (map.getSource("buffer")) {
      map.removeLayer("buffer");
      map.removeSource("buffer");
    }
    map.getCanvas().style.cursor = "grab";
    $drawClicked = false;
  }
</script>

<div class="schemePotential">
  <CalculateOperationZonePotential {bufferDrawzones} {poly} {map} {Draw} />
  <h4 style="color:white;margin:15px;font-weight:500">Operation Zone :</h4>

  <div
    class="slidecontainer"
    style="position:relative;left: 18px;font-size:12px"
  >
    <p>
      <span
        style="    text-align: justify;
  right: 20px;
  top: -7px;
  font-weight: 600;
  font-size: 22px;
  color: #D9484D
;
  position: absolute;"
      ></span>
    </p>

    <button class="drawZone" on:click={drawPoly}> Draw your own polygon</button>
    <button class="drawZone" on:click={clearPoly}
      ><i class="fa-solid fa-trash"></i></button
    >
  </div>
  <div
    class="slidecontainer"
    style="position:relative;left: 18px;font-size:12px;top:-10px"
  >
    <p>
      <span
        use:tooltip={{
          content:
            "<span style='font-size:12px'> Please choose the average journey length you would like to allow for in your local area</span>",
          position: "top",
          autoPosition: true,
          style: {
            backgroundColor: "gray",
          },
          maxWidth: 150,
        }}
        style="position: relative;
        z-index: 100000"
      >
        Select travel zone size</span
      >:
      <span
        style="text-align: justify;
  right: 25px;
  top: -7px;
  font-weight: 600;
  font-size: 22px;
  color: #0a6a5b
;
  position: absolute;"
        >{bufferDrawzones}
        <span style="font-weight: 400;font-size:16px">km</span></span
      >
    </p>

    <input
      style="margin-top: -10px;width:80%;padding:0px;accent-color:#0a6a5b"
      type="range"
      step=".5"
      min="2"
      max="10"
      bind:value={bufferDrawzones}
    />
  </div>
  <div
    class="slidecontainer"
    style="position:relative;left: 18px;font-size:12px;top:-20px"
  >
    <p>
      <span
        use:tooltip={{
          content:
            "<span style='font-size:11px'>Please choose the density of parking bays that are likely to be needed in your local area</span>",
          position: "top",
          autoPosition: true,
          style: {
            backgroundColor: "gray",
          },
          maxWidth: 175,
        }}
        style="position: relative;
  z-index: 100000"
      >
        Select parking bay density:</span
      ><span
        style="    text-align: justify;
right: 20px;
top: -7px;
font-weight: 600;
font-size: 22px;
color: #0a6a5b;
position: absolute;"
        >{parkingDensity}<span style="font-weight: 400;font-size:16px">m</span
        ></span
      >
    </p>

    <input
      style="margin-top: -10px;width:80%;padding:0px;accent-color: #0a6a5b"
      type="range"
      step="100"
      min="100"
      max="500"
      bind:value={parkingDensity}
    />
  </div>
</div>

<style>
  .drawZone {
    border-radius: 5px;
    left: 20%;
    position: relative;
  }
</style>
